import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.AccountUsageOneStep.StepForm', {
    asPartOfRequirements:
        'As part of our regulatory requirements, we need to know a bit more about how you plan to use your account...',
    primaryPurposeLabel: 'Primary purpose',
    primaryPurposePlaceholder: 'Choose primary purpose',
    sourceOfFundsLabel: 'What is your source of funds?',
    sourceOfFundsPlaceholder: 'Choose source of funds',
    initialCapital: 'Initial Capital',
    initialCapitalPlaceholder: 'Enter initial capital...',
    initialCapitalHelperText:
        'Tell us a bit more about how much initial capital was used to start this business and where it came from',
    willYouReceive: 'Will you receive money from 3rd parties into your account?',
    otherSourceOfFundsLabel: 'Source of funds',
    otherSourceOfFundsPlaceholder: 'Please provide some description of your source of funds and its amount',
    otherSourceOfFundsHelperText: 'Please provide some description of your source of funds and its amount',
    yes: 'Yes',
    no: 'No',
});

export const primaryPurposeMessages = defineMessages(
    'app.WalletsPage.KycPage.wizard.AccountUsageOneStep.StepForm.primaryPurpose',
    {
        collectingFundsFromClients: 'Collecting funds from clients',
        interCompanyTransfers: 'Inter-company transfers',
        investmentActivity: 'Investment activity',
        liquidityFx: 'Liquidity FX',
        liquidityOrFx: 'Liquidity or FX',
        other: 'Other',
        payingAnIndividual: 'Paying an individual',
        payingSuppliersOrBills: 'Paying suppliers or bills',
        paymentToAnIndividual: 'Payment to an individual',
        propertyPurchaseOrSale: 'Property purchase or sale',
        repatriatingOverseasEarnings: 'Repatriating overseas earnings',
    }
);

export const sourceOfFundsMessages = defineMessages(
    'app.WalletsPage.KycPage.wizard.AccountUsageOneStep.StepForm.sourceOfFunds',
    {
        businessRevenue: 'Business revenue',
        donationsOrGrants: 'Donations or grants',
        externalInvestment: 'External investment',
        interCompanyTransfers: 'Inter-company transfers',
        loan: 'Loan',
        other: 'Other',
        saleOfAssets: 'Sale of assets',
    }
);
